import { DelegatedTokenType, DelegatedTokenTypeType } from 'app/services/oauth/constants';
import createErrorType from 'app/utils/createErrorType';
import { decodeOrThrow } from 'app/utils/ioTs';
import * as t from 'io-ts';

export class InvalidDelegateResponseError extends createErrorType('InvalidDelegateResponseError') {
}

interface IBaseDelegateResponse {
  access_token: string;
  redirect_uri?: string;
  token_type: DelegatedTokenType;
}

interface IAuthorizationDelegateResponse extends IBaseDelegateResponse {
  access_token: string;
  token_type: DelegatedTokenType.AUTHORIZATION_CODE;
}

interface IBearerDelegateResponse extends IBaseDelegateResponse {
  token_type: DelegatedTokenType.BEARER;
  expires_in: number;
  scope: string;
  created_at: number;
}

export type DelegateResponse = IAuthorizationDelegateResponse | IBearerDelegateResponse;

const DelegateResponseCodec = t.intersection([
  t.interface({
    token_type:   DelegatedTokenTypeType,
    access_token: t.string,
  }),
  t.partial({
    redirect_uri: t.string,
  }),
  t.union([
    t.interface({
      token_type: t.literal(DelegatedTokenType.AUTHORIZATION_CODE),
    }),
    t.interface({
      token_type: t.literal(DelegatedTokenType.BEARER),
      expires_in: t.number,
      scope:      t.string,
      created_at: t.number,
    }),
  ]),
]);

export const parseDelegateResponse = (x: unknown): DelegateResponse => {
  return decodeOrThrow(DelegateResponseCodec, x, (errors) => {
    throw new InvalidDelegateResponseError(errors.join('\n'));
  });
};
